import { useState, useEffect, useRef } from "react";
import clsx from "clsx";
import ArrowDown from "../../src/assets/svg/arrowDown.svg";
import React from "react";

export interface FilterProps {
  name: string;
  data: string[];
  selected?: string[];
  onChange?: (values: string[]) => void;
  className?: string;
  multiple?: boolean;
}

export function Filter(props: FilterProps) {
  const {
    name,
    data,
    selected = [],
    onChange,
    className,
    multiple = true,
  } = props;
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  const toggleDropdown = () => setIsOpen((prev) => !prev);

  const handleSelect = (value: string) => {
    if (multiple) {
      let updatedSelection = [...selected];
      if (updatedSelection.includes(value)) {
        updatedSelection = updatedSelection.filter((item) => item !== value); // Deselect
      } else {
        updatedSelection.push(value); // Select
      }
      if (onChange) {
        onChange(updatedSelection);
      }
      setIsOpen(false);
    } else {
      if (onChange) {
        onChange([value]);
      }
      setIsOpen(false);
    }
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="relative" ref={dropdownRef}>
      {/* Dropdown Button */}
      <button
        className={clsx(
          "inline-flex w-full justify-between bg-white items-center rounded-md border border-extra-light p-3 focus:outline-none font-medium text-sm text-filter-gray",
          className
        )}
        onClick={toggleDropdown}
      >
        <span className="flex items-center gap-2">
          {multiple ? name : selected}
        </span>
        <div className="flex gap-3">
          {multiple && selected.length > 0 && (
            <span className="flex justify-center items-center bg-light-blue rounded-full w-[22px] h-[22px] text-xs font-medium">
              {selected.length}
            </span>
          )}
          <img src={ArrowDown} alt="Arrow" />
        </div>
      </button>

      {/* Dropdown Menu */}
      {isOpen && (
        <div className="absolute left-0 z-10 w-full mt-2 overflow-y-auto text-sm bg-white border rounded-md shadow-lg border-extra-light max-h-52 text-filter-gray">
          {data.map((item, index) => (
            <React.Fragment key={index}>
              {multiple ? (
                <label
                  key={index}
                  className="flex items-center justify-between px-3 py-2 cursor-pointer hover:bg-gray-100"
                >
                  <span>{item}</span>
                  <input
                    type="checkbox"
                    checked={selected.includes(item)}
                    onChange={() => handleSelect(item)}
                    className="form-checkbox text-gray-extra-dark"
                  />
                </label>
              ) : (
                <label
                  key={index}
                  className="flex items-center justify-between px-3 py-2 cursor-pointer hover:bg-gray-100"
                  onClick={() => handleSelect(item)}
                >
                  <span>{item}</span>
                </label>
              )}
            </React.Fragment>
          ))}
        </div>
      )}
    </div>
  );
}

export default Filter;
